/* eslint-disable no-debugger */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable eol-last */
/* eslint-disable semi */
import React, { useEffect, useState } from 'react';
import SimpleAlert from '@components/complex/SimpleAlert';
import Button from '@components/basic/Button';
import Multiselect from 'multiselect-react-dropdown';
import {
    brands,
    categories,
    materials,
    moqs,
    products,
    techniques,
    times,
} from '../../../constants/othersIMX';
import styles from './styles.scss';
import DropDownList from '../../components/basic/DropDownList';

function Catalogue() {
    const [activeCat, setActiveCat] = useState(categories[0]);
    const [activeProducts, setActiveProducts] = useState(products);
    const [activeMaterialsFilter, setActiveMaterialsFilter] = useState([]); // string
    console.log(activeProducts);
    const [activeMaterialsFilterTwo, setActiveMaterialsFilterTwo] = useState([]); // obj
    const [activeTechniquesFilter, setActiveTechniquesFilter] = useState([]); // string
    const [activeTechniquesFilterTwo, setActiveTechniquesFilterTwo] = useState([]); // obj
    const [moqFilter, setMoqFilter] = useState([]); // string
    const [moqFilterTwo, setMoqFilterTwo] = useState([]); // obj
    const [brandFilter, setBrandFilter] = useState([]); // string
    const [brandFilterTwo, setBrandFilterTwo] = useState([]); // obj
    const [timeFilter, setTimeFilter] = useState([]); // string
    const [timeFilterTwo, setTimeFilterTwo] = useState([]); // obj
    const [stockFilter, setStockFilter] = useState([]); // string
    const [stockFilterTwo, setStockFilterTwo] = useState([]); // obj
    const [showAlert, setShowAlert] = useState(false);
    const [activeObj, setActiveObj] = useState(null);

    // function arrayEquals(a, b) {
    //     const _a = a.sort();
    //     const _b = b.sort();
    //     return Array.isArray(_a) && Array.isArray(_b) && _a.length === _b.length && _a.every((val, index) => val === _b[index]);
    // }

    function onApply() {
        let newArr = [...products];
        // filter by material
        // if (activeMaterialsFilter.length > 0) {
        //     activeMaterialsFilter.forEach(element => products.forEach((e) => {
        //         if (e.materials.includes(element.key)) {
        //             newArr.push(e);
        //         }
        //     }));
        // }
        // sort beforehand
        if (activeMaterialsFilterTwo.length > 0) {
            activeMaterialsFilter.forEach((element) => {
                const found = newArr.filter(el => el.materials.includes(element));
                newArr = found;
            })
        }
        if (activeTechniquesFilterTwo.length > 0) {
            activeTechniquesFilter.forEach((element) => {
                const found = newArr.filter(el => el.techniques.includes(element));
                newArr = found;
            })
        }
        if (activeCat.id !== 0) {
            const found = newArr.filter(element => element.category === activeCat.name);
            newArr = found;
        }
        if (moqFilterTwo.length > 0) {
            moqFilter.forEach((element) => {
                const found = newArr.filter(el => el.moq === element);
                newArr = found;
            })
        }
        if (brandFilterTwo.length > 0) {
            brandFilter.forEach((element) => {
                const found = newArr.filter(el => el.brand === element);
                newArr = found;
            })
        }
        if (timeFilterTwo.length > 0) {
            timeFilter.forEach((element) => {
                const found = newArr.filter(el => el.timeDelivery === element);
                newArr = found;
            })
        }
        if (stockFilterTwo.length > 0) {
            stockFilter.forEach((element) => {
                const found = newArr.filter(el => el.stock === element);
                newArr = found;
            })
        }
        setActiveProducts(newArr);
    }
    function onReset() {
        setActiveMaterialsFilter([]);
        setActiveMaterialsFilterTwo([]);
        setActiveTechniquesFilter([]);
        setActiveTechniquesFilterTwo([]);
        setMoqFilterTwo([]);
        setMoqFilter([]);
        setBrandFilterTwo([]);
        setBrandFilter([]);
        setTimeFilterTwo([]);
        setTimeFilter([]);
        setStockFilter([]);
        setStockFilterTwo([]);
        setActiveCat(categories[0]);
    }
    useEffect(() => {
        if (activeCat.id === 0) {
            setActiveProducts(products);
            onApply();
        } else {
            let newArr = [];
            const found = activeProducts.filter(e => e.category === activeCat.name);
            if (found && found !== undefined) {
                newArr = found;
            }
            setActiveProducts(newArr);
            onApply();
        }
    }, [activeCat]);
    useEffect(() => {
        onApply();
    }, [activeMaterialsFilterTwo, activeTechniquesFilterTwo, moqFilterTwo, brandFilterTwo, timeFilterTwo, stockFilterTwo]);
    useEffect(() => {
        if (activeObj !== null) {
            setShowAlert(true);
        }
    }, [activeObj]);
    return (
        <>
            <SimpleAlert state={showAlert && activeObj}>
                <>
                    <div
                        className={styles.exitIcon}
                        role="button"
                        tabIndex="0"
                        onClick={() => {
                            setShowAlert(false);
                        }}
                    >
                        <svg id="closebtncross" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M1 21L21 1" stroke="#FFFFFF" />
                            <path d="M21 21L0.999999 1" stroke="#FFFFFF" />
                        </svg>
                    </div>
                    <div className={styles.wrapperProductInfo}>
                        <div className={styles.containerProductInfo}>
                            <div className={styles.productNameBig}>{`${activeObj && activeObj.name}`}</div>
                            <div className={styles.productCatBig}>{`Producto: ${activeObj && activeObj.product}`}</div>
                            <div className={styles.productCatBig}>{`Proveedor: ${activeObj && activeObj.provider}`}</div>
                            <div className={styles.productCatBig}>{`Categoría: ${activeObj && activeObj.category}`}</div>
                            <div className={styles.productCatBig}>{`Materiales: ${activeObj && activeObj.materials.join(', ')}`}</div>
                            <div className={styles.productCatBig}>{`Técnicas / Acabados: ${activeObj && activeObj.techniques.join(', ')}`}</div>
                            <div className={styles.productCatBig}>{`Marca: ${activeObj && activeObj.brand}`}</div>
                            <div className={styles.productCatBig}>{`Dimensiones: ${activeObj && activeObj.dimensions}`}</div>
                            <div className={styles.productCatBig}>{`Sustentabilidad: ${(activeObj && activeObj.sustainability) && activeObj.sustainability === true ? 'SÍ' : 'NO'}`}</div>
                            <div className={styles.productCatBig}>{`Unidad: ${activeObj && activeObj.unit}`}</div>
                            <div className={styles.productCatBig}>{`MOQ: ${activeObj && activeObj.moq}`}</div>
                            <div className={styles.productCatBig}>{`Stock: ${(activeObj && activeObj.stock) && activeObj.stock === true ? 'SÍ' : 'NO'}`}</div>
                            <div className={styles.productCatBig}>{`Rango de precio x Millar(US$): ${activeObj && activeObj.minPrice} - ${activeObj && activeObj.maxPrice}`}</div>
                            <div className={styles.productCatBig}>{`Precio x Millar(US$): ${activeObj && activeObj.price}`}</div>
                            <div className={styles.productCatBig}>{`Tiempo de entrega(dias): ${activeObj && activeObj.timeDelivery}`}</div>
                            <div className={styles.productCatBig}>{`Book: ${activeObj && activeObj.book}`}</div>
                            <div className={styles.productCatBig}>{`Articulo: ${activeObj && activeObj.id.toString()}`}</div>
                        </div>
                        <img src={activeObj && activeObj.img && activeObj.img !== "" ? activeObj.img : "https://imx-imagenes.s3.amazonaws.com/logo_img.png"} className={styles.imgBig} alt="product" />
                    </div>
                </>
            </SimpleAlert>
            <div
                className={styles.header}
                role="button"
                tabIndex={-1}
                onClick={() => {
                    window.location.href = 'https://imxperu.com/';
                }}
            >
                <svg width="60" height="33" viewBox="0 0 60 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M59.5498 27.978L51.587 15.6663L58.8434 4.44826C59.573 3.31892 59.3874 1.85642 58.4806 0.934509L48.7592 15.7878L59.1512 31.5295C60.0896 30.6097 60.29 29.1241 59.5498 27.978Z" fill="white" />
                    <path d="M57.8038 0.427433C56.5069 -0.272384 54.8557 0.134097 54.0459 1.38497L48.1962 10.4281L42.2916 1.29906C41.7475 0.458862 40.826 0 39.8876 0C39.4342 0 38.9745 0.106858 38.5548 0.331051L48.251 15.0209L57.8038 0.427433Z" fill="white" />
                    <path d="M7.08766 29.0361C9.091 29.0361 10.7 27.4269 10.7 25.4364L10.7295 2.87677V2.83696C10.7295 2.61696 10.9088 2.43886 11.1302 2.43886C11.2778 2.43886 11.4043 2.51639 11.476 2.63372L11.4781 2.6421L22.1022 18.5242L32.6819 2.69658C32.7494 2.56458 32.9055 2.47448 33.0657 2.47448C33.2914 2.47448 33.4537 2.63163 33.4537 2.85582C33.4537 2.85582 33.4179 25.4239 33.4179 25.4511C33.4179 27.4416 35.1366 29.0424 37.1399 29.0424C38.3018 29.0424 39.3309 28.4976 39.9952 27.6532L47.7534 15.8003L37.8738 0.842274C36.9522 1.76419 36.7603 3.24554 37.4942 4.38117L44.8053 15.7019C44.8053 15.7019 38.0593 26.1782 38.0045 26.2976C37.9961 26.306 37.9876 26.3164 37.9813 26.3248C37.7599 26.6894 37.3592 26.9345 36.8974 26.9345C36.2458 26.9345 35.7101 26.4443 35.6406 25.8157H35.6384V25.8052C35.6342 25.7633 35.6321 25.7214 35.6321 25.6795C35.6321 25.6376 35.6342 25.5936 35.6384 25.5517V2.83696C35.6384 1.28018 34.4175 0.00417046 32.8506 0.00417046C32.0767 0.00417046 31.4356 0.316364 30.9211 0.819227C30.7397 0.982657 30.5689 1.16914 30.4319 1.38285L22.0347 14.3462L13.6312 1.38076C13.4941 1.16704 13.2959 0.980562 13.1146 0.817131C12.6 0.314269 11.7966 0.0020752 11.0226 0.0020752C9.45793 0.00417046 8.01341 1.27809 8.01341 2.83696V25.5182C8.01341 26.2138 7.46302 26.6957 6.79875 26.6957C6.13238 26.6957 5.48287 26.2557 5.48287 25.5559V14.2352V2.62744C5.48287 1.26971 4.58032 0.169696 3.11682 0.0460757L3.19274 25.4616C3.19274 27.4521 5.08221 29.0361 7.08766 29.0361Z" fill="white" />
                    <path d="M41.155 27.4186C40.341 28.858 38.9155 29.8973 37.1335 29.8973C34.6515 29.8973 32.5786 27.9047 32.5786 25.4386L32.5722 4.23874L22.4923 19.3749L22.4733 19.4042C22.3847 19.5467 22.2266 19.6431 22.0452 19.6431C21.8681 19.6431 21.7099 19.5509 21.6213 19.4126L11.4148 4.23874C11.4148 4.23874 11.4401 25.317 11.4401 25.4239C11.4401 27.89 9.54645 29.8973 7.06442 29.8973C4.58238 29.8973 2.41877 27.9005 2.41877 25.4323L2.42299 0.0356445C1.15561 0.0985023 0 1.22366 0 2.62748V14.2373V25.2123C0 25.2668 0.08646 26.3291 0.149723 26.5553C0.714877 29.8177 3.6018 32.2985 7.04544 32.2985C10.7021 32.2985 13.6797 29.4992 13.9707 25.9393C13.977 25.8828 13.9158 25.1473 13.9158 25.0363V12.4396L19.4535 20.9086L19.6243 21.0721C20.1937 21.7342 21.0562 22.1553 22.0009 22.1553C23.0827 22.1553 24.0422 21.6063 24.5968 20.7724L24.7318 20.5524L30.0269 12.4438L29.9616 25.9708C30.2589 29.5222 33.3694 32.3026 37.0218 32.3026C39.5987 32.3026 41.853 30.9114 43.0613 28.8434L48.1941 20.9107L54.7503 31.0455C55.5495 32.2817 57.1733 32.6924 58.4617 32.0282L48.2531 16.561L41.155 27.4186Z" fill="white" />
                </svg>
            </div>
            <div className={styles.wrapper}>
                {window.innerWidth >= 1300 && (
                    <div className={styles.categories}>
                        {categories.map((item, index) => (
                            <div
                                role="button"
                                tabIndex={-1}
                                onClick={() => setActiveCat(item)}
                                className={item.id === activeCat.id ? styles.selectedCategory : styles.unitCategory}>{item.name}
                            </div>
                        ))}
                    </div>
                )}
                <div className={styles.rightSide}>
                    <div className={styles.filters}>
                        {/* <DropDownList
                            changeHandler={(e) => {
                            }}
                            currentValue={answer1}
                            filterFieldBg="#fff"
                            label="Ordenar"
                            options={[
                                { id: 1, title: 'Por precio' },
                                { id: 2, title: 'Mitigar el impacto' },
                                { id: 3, title: 'Transferir' },
                            ]}
                        /> */}
                        <div className={styles.filtersContainer}>
                            {window.innerWidth < 1300 && (
                                <DropDownList
                                    changeHandler={(e) => {
                                        const found = categories.find(element => element.name === e.target.value);
                                        if (found) {
                                            setActiveCat(found);
                                        }
                                    }}
                                    currentValue={activeCat.name}
                                    filterFieldBg="#fff"
                                    label="Categoría"
                                    options={categories}
                                />
                            )}
                            <Multiselect
                                displayValue="key"
                                hideSelectedList
                                onKeyPressFn={e => console.log('er')}
                                onRemove={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setActiveMaterialsFilter(newArr);
                                    setActiveMaterialsFilterTwo(e);
                                }}
                                onSearch={e => console.log('er')}
                                onSelect={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setActiveMaterialsFilter(newArr);
                                    setActiveMaterialsFilterTwo(e);
                                }}
                                placeholder="Materiales"
                                options={materials}
                                selectedValues={activeMaterialsFilterTwo}
                                showCheckbox
                                style={{
                                    searchBox: {
                                        background: activeMaterialsFilterTwo.length > 0 ? '#e2e2e2' : '#fff',
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                    },
                                }}
                            />
                            <Multiselect
                                displayValue="key"
                                hideSelectedList
                                onKeyPressFn={e => console.log('er')}
                                onRemove={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setActiveTechniquesFilter(newArr);
                                    setActiveTechniquesFilterTwo(e);
                                }}
                                onSearch={e => console.log('er')}
                                onSelect={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setActiveTechniquesFilter(newArr);
                                    setActiveTechniquesFilterTwo(e);
                                }}
                                placeholder="Técnicas / Acabados"
                                options={[{
                                    cat: 'Group 1',
                                    key: 'Tejido',
                                },
                                {
                                    cat: 'Group 1',
                                    key: 'Corte',
                                },
                                {
                                    cat: 'Group 1',
                                    key: 'Doblez',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Termoadhesivo',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Corte Laser',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Prensado',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Estampado',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Doblez 90°',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Colocacion de Punteras',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Enrollado',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Baño de Goma',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Impresión',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Troquelado',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Grabado Laser',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Inyeccion de Resina',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Quemado',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Inyeccion',
                                },
                                {
                                    cat: 'Group 2',
                                    key: 'Maquinado',
                                }]}
                                selectedValues={activeTechniquesFilterTwo}
                                showCheckbox
                                style={{
                                    searchBox: {
                                        background: activeTechniquesFilterTwo.length > 0 ? '#e2e2e2' : '#fff',
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                        maxHeight: 35,
                                    },
                                }}
                            />
                            <Multiselect
                                displayValue="key"
                                hideSelectedList
                                onKeyPressFn={e => console.log('er')}
                                onRemove={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setMoqFilter(newArr);
                                    setMoqFilterTwo(e);
                                }}
                                onSearch={e => console.log('er')}
                                onSelect={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setMoqFilter(newArr);
                                    setMoqFilterTwo(e);
                                }}
                                placeholder="MOQ"
                                options={moqs}
                                selectedValues={moqFilterTwo}
                                showCheckbox
                                style={{
                                    searchBox: {
                                        background: moqFilterTwo.length > 0 ? '#e2e2e2' : '#fff',
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                        maxHeight: 35,
                                    },
                                }}
                            />
                            <Multiselect
                                displayValue="key"
                                hideSelectedList
                                onKeyPressFn={e => console.log('er')}
                                onRemove={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setBrandFilter(newArr);
                                    setBrandFilterTwo(e);
                                }}
                                onSearch={e => console.log('er')}
                                onSelect={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setBrandFilter(newArr);
                                    setBrandFilterTwo(e);
                                }}
                                placeholder="Marca"
                                options={brands}
                                selectedValues={brandFilterTwo}
                                showCheckbox
                                style={{
                                    searchBox: {
                                        background: brandFilterTwo.length > 0 ? '#e2e2e2' : '#fff',
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                        maxHeight: 35,
                                    },
                                }}
                            />
                            <Multiselect
                                displayValue="key"
                                hideSelectedList
                                onKeyPressFn={e => console.log('er')}
                                onRemove={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setTimeFilter(newArr);
                                    setTimeFilterTwo(e);
                                }}
                                onSearch={e => console.log('er')}
                                onSelect={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.key);
                                    });
                                    setTimeFilter(newArr);
                                    setTimeFilterTwo(e);
                                }}
                                placeholder="Tiempo de entrega (dias)"
                                options={times}
                                selectedValues={timeFilterTwo}
                                showCheckbox
                                style={{
                                    searchBox: {
                                        background: timeFilterTwo.length > 0 ? '#e2e2e2' : '#fff',
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                        maxHeight: 35,
                                    },
                                }}
                            />
                            <Multiselect
                                displayValue="key"
                                hideSelectedList
                                onKeyPressFn={e => console.log('er')}
                                onRemove={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.value);
                                    });
                                    setStockFilter(newArr);
                                    setStockFilterTwo(e);
                                }}
                                onSearch={e => console.log('er')}
                                onSelect={(e) => {
                                    const newArr = [];
                                    e.forEach((element) => {
                                        newArr.push(element.value);
                                    });
                                    setStockFilter(newArr);
                                    setStockFilterTwo(e);
                                }}
                                placeholder="Stock"
                                options={[{
                                    cat: 'Group 1',
                                    value: true,
                                    key: 'SÍ',
                                },
                                {
                                    cat: 'Group 1',
                                    value: false,
                                    key: 'NO',
                                }]}
                                selectedValues={stockFilterTwo}
                                showCheckbox
                                style={{
                                    searchBox: {
                                        background: stockFilterTwo.length > 0 ? '#e2e2e2' : '#fff',
                                        maxWidth: '200px',
                                        minWidth: '200px',
                                        maxHeight: 35,
                                    },
                                }}
                            />
                        </div>
                        <div className="d-flex flex-row">
                            {/* <Button onClick={onApply} label="Apply" customStyle={styles.btn} disabled={activeMaterialsFilter.length < 1} /> */}
                            <Button onClick={onReset} label="Reset all" customStyle={styles.btnReset} />
                        </div>
                    </div>
                    <div className={styles.productsContainer}>
                        <div style={{ paddingRight: 10, marginBottom: 10 }}>{activeCat.description}</div>
                        <div className={styles.products}>
                            {activeProducts.length > 0 ? (
                                <>
                                    {activeProducts.map(item => (
                                        <div className={styles.unitProduct} role="button" tabIndex={-1} onClick={() => setActiveObj(item)}>
                                            <img src={item.imgMini === "" ? "https://imx-imagenes.s3.amazonaws.com/logo_img.png" : item.imgMini} className={styles.img} alt="product" />
                                            <div className={styles.productName}>{item.name}</div>
                                            <div className={styles.productCat}>{item.brand}</div>
                                        </div>
                                    ))}
                                </>
                            ) : <div>No hemos encontrado productos de acuerdo a su búsqueda.</div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Catalogue;